'use client'

import {
  MobileRefundedGuaranteedShippingNotification,
  RefundedGuaranteedShippingNotification,
} from './NotificationPanel/NotificationPanel'
import styles from './OrderSummaryCard.module.scss'
import OrderSummaryCardHeader from './OrderSummaryCardHeader/OrderSummaryCardHeader'
import OrderSummaryShipment from './OrderSummaryShipment/OrderSummaryShipment'

import React, { useState } from 'react'

import Card from 'Atoms/Card'
import CoveringSpinner from 'Atoms/CoveringSpinner'
import Divider from 'Atoms/Divider'

const OrderSummaryCard = ({ order: orderSummary, isCondensed = false }) => {
  const [isLoading, setIsLoading] = useState(false)
  const packages = orderSummary.packages ?? []
  const untrackedPackages = orderSummary.untrackedPackages ?? []

  orderSummary.isOnHold ? console.log('Order is on hold (Order Summary)') : null

  function onClickToOpenDetails(clickEvent) {
    if (!clickEvent.shiftKey && !clickEvent.ctrlKey) {
      setIsLoading(true)
    }
    // else, opened in new tab so don't show the loading spinner
  }

  return (
    <>
      <CoveringSpinner size={2} isLoading={isLoading}>
        <Card
          className={isCondensed ? styles.orderSummaryCardCondensed : styles.orderSummaryCard}
          noPadding
          noMargin
          href={isCondensed ? `/account/orderhistory/${orderSummary.publicOrderToken}` : null}
        >
          <div>
            <div>
              <OrderSummaryCardHeader
                order={orderSummary}
                onClickToOpenDetails={onClickToOpenDetails}
                isCondensed={isCondensed}
              />
            </div>

            <div className={styles.shipmentsContainer}>
              {packages.map((orderPackage, index) => (
                <React.Fragment key={index}>
                  <OrderSummaryShipment
                    orderSummary={orderSummary}
                    orderPackage={orderPackage}
                    totalShipments={packages.length}
                    shipmentIndex={index}
                    className={styles.shipment}
                    onClickToOpenDetails={onClickToOpenDetails}
                    isCondensed={isCondensed}
                  />
                  {(untrackedPackages.length > 0 || index !== packages.length - 1) && (
                    <div className={styles.shipmentDivider}>
                      <Divider />
                    </div>
                  )}
                </React.Fragment>
              ))}

              {untrackedPackages.map((untrackedPackage, index) => (
                <React.Fragment key={index}>
                  <OrderSummaryShipment
                    orderSummary={orderSummary}
                    orderPackage={untrackedPackage}
                    isUntrackedPackage
                    className={styles.shipment}
                    onClickToOpenDetails={onClickToOpenDetails}
                    isCondensed={isCondensed}
                  />

                  {index !== untrackedPackages.length - 1 && (
                    <div className={styles.shipmentDivider}>
                      <Divider />
                    </div>
                  )}
                </React.Fragment>
              ))}
              {orderSummary.isGuaranteedPromiseKept === false && (
                <>
                  <RefundedGuaranteedShippingNotification className={styles.orderNotification} />
                  <MobileRefundedGuaranteedShippingNotification className={styles.orderNotification} />
                </>
              )}
            </div>
          </div>
        </Card>
      </CoveringSpinner>
    </>
  )
}

export default OrderSummaryCard
